export default __webpack_public_path__ + "static/media/yt.664a05c4.svg";